export default "__VITE_ASSET__w8l2O1PW__"